var render = function render(){var _vm=this,_c=_vm._self._c;return _c('with-title',{attrs:{"title":_vm.$t('video.views'),"subtitle":_vm.videos.length.toString()}},[_c('video-gallery',{attrs:{"videos":_vm.videos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }